import React, { useEffect, useState } from 'react';
import { Alert, Platform } from 'react-native';
import { Center, Button, Modal, FormControl, Text, Box, Input, useTheme } from 'native-base';
import { useDebounce } from 'use-debounce';
import { DEVICE_WIDTH } from '../Constants';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { searchAPI } from '../../context/search';
import Confirm from '../content/common/reusables/Confirm';
import { LANGUAGES } from '../Constants';
const MovePost = _ref => {
  let {
    reply,
    showModal,
    setShowModal,
    movePostToAnotherTopic
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const authState = useAuthState();
  const envState = useEnvState();
  const [topicsResult, setTopicsResult] = useState([]);
  //   const [groupedSearchResult, setGroupedSearchResult] = useState([]); // another accessible value
  //   const [postsResult, setPostsResult] = useState([]); // another accessible value
  const [selectedTopic, setSelectedTopic] = useState({});
  const [noResultText, setNoResultText] = useState('');
  const textWithNoResult = 'No topic(s) found';
  const [term, setTerm] = useState('');
  const requiredInputLength = 3;
  const delayTimeInMilliSeconds = 1000;
  const [debouncedValue] = useDebounce(term, delayTimeInMilliSeconds);
  const isInputValid = term.length >= requiredInputLength;
  const isDestinationSame = (reply === null || reply === void 0 ? void 0 : reply.topic_id) === (selectedTopic === null || selectedTopic === void 0 ? void 0 : selectedTopic.id);
  useEffect(() => {
    if (isInputValid) {
      doSearch();
    }
  }, [debouncedValue]);
  useEffect(() => {
    if (term.length === 0) {
      setNoResultText('');
    }
  }, [term]);
  const doSearch = async () => {
    try {
      setTopicsResult([]);
      const response = await searchAPI.searchTopic(envState.base_url, debouncedValue, authState.api_key);
      if (!response) {
        setNoResultText(textWithNoResult);
        throw new Error('Failed to get search result. Please try again');
      }
      const {
        grouped_search_result,
        posts,
        topics
      } = response;

      //   setGroupedSearchResult(grouped_search_result);
      //   setPostsResult(posts);

      if (!topics || (topics === null || topics === void 0 ? void 0 : topics.length) === 0) {
        setNoResultText(textWithNoResult);
        return [];
      } else {
        setNoResultText('');
      }

      // remove the current topic from search result
      const topicsWithoutCurrentTopic = topics.filter(topic => topic.id !== (reply === null || reply === void 0 ? void 0 : reply.topic_id));
      setTopicsResult(topicsWithoutCurrentTopic);
      return response;
    } catch (err) {
      console.log('Error while searching for topic');
      setNoResultText(textWithNoResult);
      return [];
    }
  };
  const handleMovePost = () => {
    const onConfirmYes = async () => {
      await movePostToAnotherTopic(reply === null || reply === void 0 ? void 0 : reply.topic_id, reply === null || reply === void 0 ? void 0 : reply.id, selectedTopic === null || selectedTopic === void 0 ? void 0 : selectedTopic.id);
      setTerm('');
      setShowModal(false);
    };
    if (!isDestinationSame) {
      const title = 'Confirm';
      const message = `Moving this reply to topic: ${selectedTopic === null || selectedTopic === void 0 ? void 0 : selectedTopic.title}. Proceed?`;
      const buttons = [{
        text: 'Yes',
        onPress: onConfirmYes
      }, {
        text: 'Cancel',
        style: 'cancel'
      }];
      if (Platform.OS === 'web') {
        return Confirm.confirm(title, message, buttons, onConfirmYes);
      } else {
        return Alert.alert(title, message, buttons);
      }
    }
    return;
  };
  return /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: showModal,
    onClose: () => setShowModal(false),
    size: 'xl',
    justifyContent: 'center',
    alignItems: 'center',
    h: '100%'
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    maxWidth: Platform.OS === 'web' ? null : DEVICE_WIDTH
  }, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, null, "Search Topic"), /*#__PURE__*/React.createElement(Modal.Body, {
    h: 96
  }, /*#__PURE__*/React.createElement(FormControl, {
    isRequired: true,
    isInvalid: !isInputValid
  }, /*#__PURE__*/React.createElement(FormControl.Label, null, "Enter search query"), /*#__PURE__*/React.createElement(Input, {
    value: term,
    placeholder: LANGUAGES.PLACEHOLDERS.MOVE_POST,
    accessibilityLabel: 'search topics',
    onChangeText: text => setTerm(text),
    autoCapitalize: 'none',
    width: '100%',
    mb: 2
  }), !isInputValid && (term === null || term === void 0 ? void 0 : term.length) === 0 && /*#__PURE__*/React.createElement(FormControl.ErrorMessage, null, (term === null || term === void 0 ? void 0 : term.length) === 0 ? 'Please enter something.' : 'Please enter at least 3 characters.')), (topicsResult === null || topicsResult === void 0 ? void 0 : topicsResult.length) > 0 ? topicsResult.map(topic => /*#__PURE__*/React.createElement(Box, {
    key: topic.title + topic.id.toString(),
    bg: selectedTopic.id === topic.id ? colors.movePost.bg.selected : colors.movePost.bg.default
  }, /*#__PURE__*/React.createElement(Text, {
    color: selectedTopic.id === topic.id ? colors.movePost.text.selected : colors.movePost.bg.default,
    onPress: () => setSelectedTopic(topic)
  }, topic.id, ": ", topic.title))) : /*#__PURE__*/React.createElement(Text, {
    mt: 1
  }, noResultText)), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button.Group, {
    space: 2
  }, /*#__PURE__*/React.createElement(Button, {
    variant: 'ghost',
    colorScheme: 'blueGray',
    onPress: () => setShowModal(false)
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onPress: () => {
      handleMovePost();
    },
    isDisabled: !isInputValid || isDestinationSame || topicsResult.length === 0 || !topicsResult
  }, "Move"))))));
};
export default MovePost;
//# sourceMappingURL=MovePost.js.map